// extracted by mini-css-extract-plugin
export default {"pageWrap":"xb-z","fullWidth":"yb-z","heading":"zb-z","fullBleed":"Ab-z","hidden":"Bb-z"};